// extracted by mini-css-extract-plugin
export var typingIndicator = "_pm-0";